import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import brandResources from './brandTranslations'
import mediaTranslations from './mediaTranslations'
import settingsTranslations from './settingsTranslations'
import notificationTranslations from './notifications/translations'
import drawingTranslations from './drawing/translations'
import inAppTranslations from './inApp/translations'
import locationTranslations from './location/translations'
import { languageDetection } from './utils/storage'
import { translationRequest } from './utils/translationRequest'

const resources = Object.fromEntries(Object.entries(brandResources).map(([language, namespaces]) =>
  [language, { ...namespaces, media: mediaTranslations[language], settings: settingsTranslations[language],
    notifications: notificationTranslations[language] || notificationTranslations.en,
    drawing: drawingTranslations[language] || drawingTranslations.en,
    location: locationTranslations[language] || locationTranslations.en,
    inApp: inAppTranslations[language] || inAppTranslations.en }]));

// Startup can validate the session in parallel, but must not race a second
// language switch against the detector's still-pending initialization.
export const initialization = i18n
  // Подключение бэкенда i18next
  .use(Backend)
  // Автоматическое определение языка 
  .use(LanguageDetector)
  // модуль инициализации
  .use (initReactI18next)
  .init({
    // Стандартный язык
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    load: 'languageOnly',
    debug: false,
    resources,
    partialBundledLanguages: true,
    // A failed download must release cold startup and the explicit Retry UI.
    // Avoid multiplying its bounded timeout by the connector's six attempts.
    maxRetries: 0,
    backend: { request: translationRequest },
    ns: ['translation', 'brand', 'media', 'settings', 'notifications', 'drawing', 'inApp', 'location'],
    defaultNS: 'translation',
    // Распознавание и кэширование языковых кук
    detection: languageDetection,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n;
